<template>
  <div class="viewcontent" v-if="translations.login">
    <form @submit.prevent="processLogin()">
      <Alert type="warning" :list="findError"/>
      <div>
        <input
          class="form-control"
          type="email"
          v-model.trim="data.email"
          :placeholder="translations.login.form_email"
          @keyup.enter="processLogin()"
        />
      </div>
      <br />
      <div>
        <input
          class="form-control"
          type="password"
          autocomplete="on"
          v-model.trim="data.password"
          :placeholder="translations.login.form_password"
          @keyup.enter="processLogin()"
        />
      </div>
      <br />
      <div>
        <button class="btn btn-link mb-2" type="button" @click="checkRecoverEmail()">
          {{ translations.buttons.btn_forget_password }}
        </button>
        <div>

          <button class="btn btn-danger" type="button" @click="goFront()">
            {{ translations.buttons.btn_cancel }}
          </button>
          &nbsp;
          <input
          class="btn btn-primary"
          type="submit"
          :class="checkData() ? 'btn btn-primary' : 'btn btn-secondary'"
          :disabled="!checkData()"
          :value="translations.buttons.btn_login"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import Alert from '@/components/atoms/Alert.vue'
  import md5 from 'js-md5'
  export default {
    name: 'Login',
    components: {
      Alert,
    },
    data() {
      return {
        data: { email: '', password: '' },
        errorsform: [],
      }
    },
    computed: {
      ...mapState(['errors', 'translations', 'front', 'info']),
      findError() {
        let result = []
        if (this.errorsform?.length > 0) {
          this.errorsform.forEach((element) => {
            result.push(this.translations.errors[element])
          })
        }
        if (this.errors?.login?.length > 0) {
          result.push(this.translations.errors[this.errors.login[0]])
        }
        if (this.info?.login?.length > 0) {
          result.push(this.info.login[0])
        }

        return result
      },
    },
    methods: {
      ...mapActions(['login', 'resetError', 'recoverPassword']),
      processLogin() {
        const reEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (this.data.email && this.data.password) {
          if (reEmail.test(this.data.email)) {
            let dataFormated = {
              email: this.data.email,
              password: this.encrypt(this.data.password),
            }
            this.login(dataFormated)
          } else {
            this.errorsform.push('invalid_email')
          }
        }
      },
      resetErrorsForm() {
        this.errorsform = []
      },
      checkRecoverEmail() {
        this.resetErrorsForm();
        if (this.data.email) {
          this.recoverPassword(this.data.email)

        } else {
          this.errorsform.push('reset_email_needed')
        }
      },
      goFront() {
        window.location.href = this.front
      },

      encrypt(pwd) {
        pwd = md5(pwd)
        return pwd
      },
      checkData() {
        return this.data.email.length > 0 && this.data.password.length > 5
      },
    },
    beforeUnmount() {
      this.resetError()
    },
  }
</script>

<style scoped>
  input[type='email'],
  input[type='password'] {
    margin: 0 auto;
    width: 80%;
  }
  @media screen and (min-width: 800px) {
    input[type='email'],
    input[type='password'] {
      margin: 0 auto;
      width: 30%;
    }
  }
</style>
